import script from "./UnlockCharachterComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./UnlockCharachterComponent.vue?vue&type=script&setup=true&lang=js"

import "./UnlockCharachterComponent.vue?vue&type=style&index=0&id=7f3fec1a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f3fec1a"]])

export default __exports__